import { useEffect } from 'react';
import { Flag } from '@weave/schema-gen-ts/dist/schemas/feature-flags/feature_flags_types.pb';
import { useQueryClient } from 'react-query';
import { useLocationService } from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, TextField, useForm } from '@frontend/design-system';
import { useUpdateFlagMutation } from '../queries';

type Props = {
  modalProps: ModalControlModalProps;
  flag?: Flag;
};

export const EditFlagModal = ({ modalProps, flag }: Props) => {
  const { currentLocationId: locationId } = useLocationService();
  const queryClient = useQueryClient();
  const { mutate: updateFlag } = useUpdateFlagMutation({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries([locationId, 'location-feature-flags']);
        queryClient.invalidateQueries(['feature-flags']);
        queryClient.invalidateQueries(['locations-with-flag']);
        modalProps.onClose();
      },
    },
  });

  const { getFieldProps, seedValues, values } = useForm({
    fields: {
      name: { type: 'text' },
      description: { type: 'text' },
    },
  });

  useEffect(() => {
    seedValues({
      name: flag?.name,
      description: flag?.description,
    });
  }, [flag?.name, flag?.description]);

  return (
    <Modal {...modalProps} minWidth={400}>
      <Modal.Header onClose={modalProps.onClose}>{'Edit Feature Flag'}</Modal.Header>

      <Modal.Body css={{ paddingTop: theme.spacing(2) }}>
        <TextField {...getFieldProps('name')} label='Flag Name' disabled />
        <TextField {...getFieldProps('description')} label='Flag Description' />
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: 'Update Description',
          onClick: () => {
            updateFlag({
              flag: {
                ...flag,
                name: values.name || flag?.name,
                description: values.description || flag?.description,
              },
            });
          },
        }}
        secondary={{
          label: 'Cancel',
          onClick: modalProps.onClose,
        }}
      />
    </Modal>
  );
};
